 
import "./profile.css";  
import Header from "../../components/header/Header";  
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import ManageAddress from "../../components/manageAddress/ManageAddress";
import ProfileInformation from "../../components/profileInformation/ProfileInformation";
import MyReviewRating from "../../components/myreviewrating/MyReviewrating";

function Profile() {
    
    return (
        <>
        <Header /> 
        <div className="container-fluid bg_gray">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 pt_20 pb_40 mb_30 ">
                        <div className="profile_box mt_30">
                             <div className="mt-4"> 
                                <div class="d-flex gap-4 align-items-start">
                                  <div className="left_panel">
                                    {/* <div className="left_panel_user_pic">
                                       <div className="d-flex gap_10 align_center pt_15 pb_15 pl_15 pr_15">
                                         <div className="user_name">
                                          <p>Jogendra Singh</p>
                                        </div>
                                       </div>
                                    </div> */}
                                    <div className="left_panel_tabs pt_15 pb_15 ">
                                    <ul class="nav nav-pills flex-column nav-pills" id="pills-tab" role="tablist">
                                      <li class="nav-item" role="presentation">
                                        <button class="nav-link fw-semibold active position-relative" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-profile-info" type="button" role="tab" aria-controls="pills-profile-info" aria-selected="true">Profile Information</button>
                                      </li>
                                      <li class="nav-item" role="presentation">
                                        <button class="nav-link fw-semibold position-relative" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-manage-address" type="button" role="tab" aria-controls="pills-manage-address" aria-selected="false">Manage Addresses</button>
                                      </li>
                                      <li class="nav-item" role="presentation">
                                        <button class="nav-link fw-semibold position-relative" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-review-rating" type="button" role="tab" aria-controls="pills-review-rating" aria-selected="false">My Reviews & Ratings</button>
                                      </li> 
                                    </ul>
                                    </div>
                                </div>
                            <div class="tab-content w-100" id="pills-tabContent">
                              <div class="tab-pane fade show active" id="pills-profile-info" role="tabpanel" aria-labelledby="pills-profile-info">
                               
                                 <ProfileInformation />
                              
                              </div>
                              <div class="tab-pane fade" id="pills-manage-address" role="tabpanel" aria-labelledby="pills-manage-address">
                                 <ManageAddress />
                              </div>
                              <div class="tab-pane fade" id="pills-review-rating" role="tabpanel" aria-labelledby="pills-review-rating">
                                <MyReviewRating />
                              </div> 
                            </div>
                          </div>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Subscribe /> 
        <Footer />
        </>
    );
}

export default Profile;
